module.exports = __webpack_public_path__ + "ad.2f0263e0.svg";